import FooterDesktop from './FooterDesktop.js';
import FooterMobile from './FooterMobile.js';

export { FooterDesktop, FooterMobile };
